const initialQueryStringParameters = Object.fromEntries(new URLSearchParams(window.location.search))
const urlReturnTo = initialQueryStringParameters.return_to
const ONE_DAY = 24 * 60 * 60 * 1000
const now = new Date()

const storedExpiration = localStorage.getItem('expiration')
const isReturnToExpired = storedExpiration ? (now > new Date(storedExpiration)) : false

if (isReturnToExpired) {
  localStorage.removeItem('returnTo')
  localStorage.removeItem('expiration')
}

if (urlReturnTo) {
  localStorage.setItem('returnTo', urlReturnTo)
  localStorage.setItem('expiration', new Date(now.getTime() + ONE_DAY))
}

const useReturnTo = () => {
  return localStorage.getItem('returnTo')
}

export { useReturnTo }
